import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import Input from 'Components/Atoms/Input/Input';
import { useTranslation } from 'react-i18next';
import OutlineSearch from 'Components/Atoms/OutlineIcons/OutlineSearch';

export default function SelectProductFilter(props) {
    const { value, onChange, className } = props;
    const { t } = useTranslation('common');

    return (
        <div className={cn('p-2 sticky top-0 bg-white z-10', className)}>
            <Input
                value={value}
                onChange={onChange}
                placeholder={t('products-filter-placeholder')}
                className="pl-8"
                size="small"
                autoFocus
            />

            <OutlineSearch
                className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
                size={18}
            />
        </div>
    );
}

SelectProductFilter.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};
